export default __webpack_public_path__ + "47cfea191521700fbbffbf614303e7c8.svg";